import api from './api';

/**
 * 智坊创意中心(idea-intel)API
 * 独立采集通道:采集器"AI创意情报"通道上传 → 攒批 LLM 提炼 → 创意卡片。
 * 后端一律以 JWT 的用户为准,前端无需也不能传 userId。
 */

export interface IdeaCard {
  id: string;
  category: string; // 工具创意|技术动向|实践案例|生态思路
  title: string;
  content: string;
  inspiration?: string | null;
  /** 对智坊的可借鉴度 1~5 */
  score: number;
  status: 'new' | 'read' | 'adopted' | 'ignored';
  batchId: string;
  sourceMsgIds?: string[] | null;
  /** 网络来源链接(高速公路网络情报采集工具上报的创意) */
  sourceUrl?: string | null;
  /** 网络来源名(Bing搜索/搜狗微信/百度搜索 等) */
  sourceName?: string | null;
  occurredAt?: string | null;
  createdAt: string;
  updatedAt?: string;
  /** 列表接口补充的来源信息(首条源消息的会话) */
  source?: { talkerName: string; isGroup: boolean; sender: string } | null;
}

export interface IdeaTraceMsg {
  msgId: string;
  time?: string | null;
  talker: string;
  talkerName: string;
  isGroup: boolean;
  sender: string;
  content: string;
}

export interface IdeaBatch {
  id: string;
  msgCount: number;
  triggerReason: string;
  modelUsed?: string | null;
  promptTokens: number;
  completionTokens: number;
  status: string;
  error?: string | null;
  startedAt: string;
  finishedAt?: string | null;
}

export interface IdeaOverview {
  total: number;
  newCount: number;
  adopted: number;
  batches: number;
  lastBatch?: { startedAt: string; status: string } | null;
  categories: Array<{ category: string; count: number }>;
}

export const ideaIntelApi = {
  overview: async (): Promise<IdeaOverview> => {
    const r = await api.get('/idea-intel/overview');
    return r.data;
  },
  ideas: async (page = 1, pageSize = 20, category?: string, status?: string, keyword?: string) => {
    const r = await api.get('/idea-intel/ideas', { params: { page, pageSize, category, status, keyword } });
    return r.data;
  },
  /** 创意溯源:该卡片依据的原始聊天消息 */
  ideaTrace: async (id: string) => {
    const r = await api.get(`/idea-intel/ideas/${id}/trace`);
    return r.data;
  },
  updateStatus: async (id: string, status: string) => {
    const r = await api.patch(`/idea-intel/ideas/${id}/status`, { status });
    return r.data;
  },
  batches: async (page = 1, pageSize = 20) => {
    const r = await api.get('/idea-intel/batches', { params: { page, pageSize } });
    return r.data;
  },
  retryBatch: async (batchId: string) => {
    const r = await api.post(`/idea-intel/retry/${batchId}`);
    return r.data;
  },
  bufferStatus: async () => {
    const r = await api.get('/idea-intel/buffer-status');
    return r.data;
  },
};
